import useApi from "./useApiRequest";
import { useMutation } from "react-query";

export const CreateRol = () => {
  const api = useApi();

  const mutate = async (params) => {
    const data = await api.post(`/roles`, params, {
      dataType: "json",
      hasFormData: false,
      hasCustomUrl: false,
    });
    return data.data;
  };

  const mutation = useMutation(mutate);

  return {
    createRolMutation: mutation.mutate,
  };
}